export const API_HOST = "http://localhost:3000";
export const API_GET_DATA = `${API_HOST}/posts/1`;
